let checkEmail = [
    v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Vpisani email naslov ni pravilen.',
];

let checkEmailAll = function(email){
    for(const rule of checkEmail){
        let result = rule(email);
        if (result !== true){
            return result;
        }
    }
    return true;
}

let checkCardNumber = [
    v => v && v.length > 0 || 'Polje je obvezno.',
    //v => v && v.length == 13 || 'Številka kartice ni pravilna'
];

let checkCardNumberAll = function(card){
    for(const rule of checkCardNumber){
        let result = rule(card);
        if (result !== true){
            return result;
        }
    }
    return true;
}


let checkNameLastname = [
    v => v && v.length > 0 || 'Polje je obvezno.'
];

let checkStreetName = [
    v => v && v.length > 0 || 'Polje je obvezno.'
];

let checkHouseNumber = [
    v => v && v.length > 0 || 'Polje je obvezno.'
];

let checkZIPNumber = [
    v => v && v.length > 0 || 'Polje je obvezno.',
    v => v && v.length > 0 && isNaN(v) == false || 'Napačna številka.',
];

let checkCity = [
    v => v && v.length > 0 || 'Polje je obvezno.'
];

let checkCountry = [
    v => v && v.length > 0 || 'Polje je obvezno.'
];

let checkGender = [
    v => {
        return v && v.toString().length > 0 || 'Polje je obvezno.'
    }
];

let checkDateOfBirth = [
    v => v && v.length > 0 || 'Polje je obvezno.'
];

let checkDateOfBirthClub = [
    v => {
        v && v.length > 0 || 'Polje je obvezno.'
    }
];

let checkPhoneNumber = [
    v => {
        if (v && v.length > 0) {
            if (isNaN(v)){
                return 'Neveljavna telefonska številka.'
            }
            return false;
        }
        return true;
    }
];

let checkPhoneNumberLand = [
    v => v && v.length > 0 || 'Polje je obvezno.'
];

let checkEducation = [
    //v => v && v.length > 0 || 'Polje je obvezno.'
];

let checkFamilyMember = [
    //v => v && v.length > 0 || 'Polje je obvezno.'
];

let checkPersonStatus = [
    //v => v && v.length > 0 || 'Polje je obvezno.'
];

let newPasswordRules = [
    v => v && v.length > 7 || 'Minimalno 8 znakov.'
];

let newPasswordCheckAgain = function (value, value_again) {
    if (value){
        return value == value_again || 'Gesli se ne ujemata.';
    } else {
        return 'Potrdi geslo s ponovnim vnosom.';
    }
};

let checkVAT = [
    v => v && v.length == 8 || 'Vnesite pravilno davčno številko.'
];

let checkPINNumber = [
    v => v && v.length > 0 || 'Polje je obvezno.'
];



export default {
    checkEmail,
    checkEmailAll,
    checkCardNumber,
    checkCardNumberAll,
    checkNameLastname,
    checkStreetName,
    checkHouseNumber,
    checkZIPNumber,
    checkCity,
    checkCountry,
    checkDateOfBirth,
    checkDateOfBirthClub,
    checkPhoneNumber,
    checkPhoneNumberLand,
    checkEducation,
    checkFamilyMember,
    checkPersonStatus,
    newPasswordRules,
    newPasswordCheckAgain,
    checkGender,
    checkVAT,
    checkPINNumber
}
